<footer class="w-100">
    <div class="w-100 flex-space-around footerRow">
        <div class="btnSizing">
            <a class="text-white" href="https://www.explainresearch.co.uk/" mat-button target="_blank"><small>Ⓒ
                Explain {{ today | date:"yyyy" }}</small></a>
        </div>
        <div>
            <button [routerLink]="['/privacy-policy']" class="text-white" mat-button><small>Privacy policy</small>
            </button>
        </div>
        <div>
            <button [routerLink]="['/terms-and-conditions']" class="text-white" mat-button><small>Terms &
                conditions</small></button>
        </div>
        <div>
            <a routerLink="/account-deletion" class="text-white" mat-button><small>Account deletion</small></a>
        </div>
        <div>
            <a class="text-white" href="https://www.nebulalabs.co.uk/" mat-button target="_blank"><small>Built by Nebula
                Labs</small></a>
        </div>
    </div>
</footer>
